<ng-container *ngIf="(isMobile$ | async) === false; else mobile">
  <ng-container *ngIf="isBookingRoute; else treatment">
    <app-modal>
      <ng-container content>
        <ng-container *ngTemplateOutlet="treatment"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-container>

<ng-template #mobile>
  <ng-container *ngTemplateOutlet="treatment"></ng-container>
</ng-template>

<ng-template #treatment>
  <div class="route-cont"
    [class.{{animation}}]="isMobile$ | async"
    [class.animated]="isMobile$ | async"
    [class.no-booking]="!isBookingRoute">
    <ng-container [ngSwitch]="country">
      <ng-container *ngSwitchCase="countries.Colombia">
        <ng-container *ngTemplateOutlet="infoCO"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="countries.Argentina">
        <ng-container *ngTemplateOutlet="infoAR"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="countries.Mexico">
        <ng-container *ngTemplateOutlet="infoMX"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="countries.Brazil">
        <ng-container *ngTemplateOutlet="infoBR"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="countries.Peru">
        <ng-container *ngTemplateOutlet="infoPE"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="infoDefault"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #infoDefault>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #infoCO>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CHUBB">
      <ng-container *ngTemplateOutlet="chubbTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.DAVIVIENDA">
      <ng-container *ngTemplateOutlet="daviviendaTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #infoMX>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CASHBACK30MX">
      <ng-container *ngTemplateOutlet="cashback30Terms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #infoAR>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.INSTALLMENTS">
      <ng-container *ngTemplateOutlet="installmentsTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.GYRA_TRAVESIA">
      <ng-container *ngTemplateOutlet="gyraTravesiaTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.PREVIAJE_II">
      <ng-container *ngTemplateOutlet="previajeIITerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.BLACK_WEEKEND">
      <ng-container *ngTemplateOutlet="blackWeekendTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.HOTELS_OFF_TRAVEL">
      <ng-container *ngTemplateOutlet="hotelsOffTravelTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CHUBB">
      <ng-container *ngTemplateOutlet="chubbTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.HOTELS_5_PER">
      <ng-container *ngTemplateOutlet="hotel5PerTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.DUTY_FREE">
      <ng-container *ngTemplateOutlet="dutyFree"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #infoBR>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.ELO">
      <ng-container *ngTemplateOutlet="eloTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.LIVELO">
      <ng-container *ngTemplateOutlet="liveloTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.TUDO_AZUL">
      <ng-container *ngTemplateOutlet="tudoAzulTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.PONTOS_DOTZ">
      <ng-container *ngTemplateOutlet="pontosDotzTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.RAPPICARD_TERMS">
      <ng-container *ngTemplateOutlet="rappicardTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CASHBACK_HOTELS_AND_CARS">
      <ng-container *ngTemplateOutlet="hotelsAndCars"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.BLACK_FRIDAY">
      <ng-container *ngTemplateOutlet="blackFriday"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CHUBB">
      <ng-container *ngTemplateOutlet="chubbTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #infoPE>
  <ng-container [ngSwitch]="infoType">
    <ng-container *ngSwitchCase="specialInfoTypes.CIVITATIS">
      <ng-container *ngTemplateOutlet="civitatisTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.CHUBB">
      <ng-container *ngTemplateOutlet="chubbTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="specialInfoTypes.RAPPI_TRAVEL">
      <ng-container *ngTemplateOutlet="rappiTravelTerms"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="cashbackTerms"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #cashbackTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermCashback }"></ng-container>
</ng-template>

<ng-template #cashback30Terms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermCashback30 }"></ng-container>
</ng-template>

<ng-template #eloTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermELO }"></ng-container>
</ng-template>

<ng-template #liveloTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermLIVELO }"></ng-container>
</ng-template>

<ng-template #tudoAzulTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermTudoAzul }"></ng-container>
</ng-template>

<ng-template #pontosDotzTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermPontosDotz }"></ng-container>
</ng-template>

<ng-template #rappicardTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermRappiCard }"></ng-container>
</ng-template>

<ng-template #hotelsAndCars>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermHotelsAndCars }"></ng-container>
</ng-template>

<ng-template #blackFriday>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetBlackFridayTravel }"></ng-container>
</ng-template>

<ng-template #installmentsTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermInstallments }"></ng-container>
</ng-template>

<ng-template #blackWeekendTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermBlackWeekend }"></ng-container>
</ng-template>

<ng-template #hotelsOffTravelTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermHotelsOffTravelTerms }"></ng-container>
</ng-template>

<ng-template #gyraTravesiaTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermGyraTravesia }"></ng-container>
</ng-template>

<ng-template #previajeIITerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetTermPreviajeII }"></ng-container>
</ng-template>

<ng-template #chubbTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetChubbTerms }"></ng-container>
</ng-template>

<ng-template #civitatisTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetCivitatisTerms }"></ng-container>
</ng-template>

<ng-template #daviviendaTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetDiviviendaTerms }"></ng-container>
</ng-template>

<ng-template #rappiTravelTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetRappiTravelTerms }"></ng-container>
</ng-template>

<ng-template #dutyFree>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetDutyFreeTerms }"></ng-container>
</ng-template>

<ng-template #hotel5PerTerms>
  <ng-container *ngTemplateOutlet="baseBodyTemplate; context: { termsData: assetHotel5PerTerms }"></ng-container>
</ng-template>

<ng-template #baseBodyTemplate let-termsData='termsData'>
  <div class="header">
    <span class="title">{{termsData?.Header}}</span>
    <a (click)="goBack()" class="close-button">
      <i aria-hidden="true" class="icon-close"></i>
    </a>
  </div>
  <div class="content-terms-conditions">
    <div class="box-content">
      <div class="page-title" *ngIf="!isBookingRoute">
        <h4>{{termsData?.Header}}</h4>
      </div>
      <ng-container *ngIf="!!termsData">
        <ng-container *ngFor="let item of termsData.Body">
          <ng-container *ngIf="!!item.Title">
            <p><strong>{{item.Title}}</strong></p>
          </ng-container>
          <ng-container *ngFor="let paragraph of item.Paragraphs">
            <p [innerHTML]="paragraph"></p>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
